<section class="problem-section" id="constat">
  <div class="container">
    <div class="section-header">
      <span class="section-badge">Le constat comptable</span>
      <h2>L'automatisation transforme votre métier</h2>
      <p>Les solutions comptables modernes automatisent la saisie. Il est temps d'évoluer vers le conseil à forte valeur ajoutée.</p>
    </div>

    <div class="problem-grid">
      <div class="problem-card fade-in-up">
        <div class="problem-icon">📉</div>
        <h3>Marges sous pression</h3>
        <p>L'automatisation des logiciels comptables réduit mécaniquement vos honoraires. De nouvelles sources de revenus deviennent essentielles</p>
        <div class="value-stat">
          <img src="/images/landing/star.svg" alt="Star" class="star-icon">
          −15% en 5 ans
        </div>
      </div>

      <div class="problem-card fade-in-up delay-1">
        <div class="problem-icon">🤖</div>
        <h3>Automatisation généralisée</h3>
        <p>Les logiciels font désormais la saisie et les déclarations automatiquement. Le conseil à forte valeur ajoutée devient votre seule différenciation</p>
        <div class="value-stat">
          <img src="/images/landing/star.svg" alt="Star" class="star-icon">
          70% automatisé
        </div>
      </div>

      <div class="problem-card fade-in-up delay-2">
        <div class="problem-icon">💬</div>
        <h3>Forte demande client</h3>
        <p>Vos clients PME vous sollicitent pour du conseil patrimonial personnalisé mais vous manquez d'outils adaptés pour y répondre efficacement</p>
        <div class="value-stat">
          <img src="/images/landing/star.svg" alt="Star" class="star-icon">
          85% en demande
        </div>
      </div>
    </div>
  </div>
</section>

